import { useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import IconPlay from '@/components/UI/svg/blade/treaser/Play';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { youtubeMap } from '@/constants/delta2max';

export default function Z1({ stage }: any) {
    const { useLang, useRouter, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const [infoAni, setInfoAni] = useState('');

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: stage === 'detail' ? 'Product Detail_1' : 'Product_1',
            __btn_id1: css.d2xZ1,
            __btn_id2: t('sec1_watch'),
        });
    };

    useEffect(() => {
        setInfoAni('top-info-ani');
    }, []);

    return (
        <div className={`d2x-Z1 ${css.d2xZ1} GtmModuleData-section`} id="d2x-Z1" data-section-id={css.d2xZ1} data-section-title={t('sec1_title')}>
            <div className={`sec1 ${stage === 'detail' ? 'sec1-detail' : ''}`}>
                <div className="main-box">
                    <div className="img-box">
                        <NextImage
                            webpSrc={require(`@publicLocal/delta2max/teaser/pc/${locale === 'za' ? 'za/1.jpg' : 'eu/1.webp'}`)}
                            src={require(`@publicLocal/delta2max/teaser/pc/${locale === 'za' ? 'za' : 'eu'}/1.jpg`)}
                            alt={t('sec1_title')}
                            aria-label={t('sec1_title')}
                        />
                    </div>
                    <div className={`top-info ${infoAni} ${stage}`}>{stage === 'teaser' ? t('sec1_top_note') : t('sec1_top_note2')}</div>
                    <div className="text-box">
                        <p className="title">{t('sec1_title')}</p>
                        <div className="subtitle-box">
                            <div className="subtitle-text">{t('sec1_subtitle')}</div>
                            {stage === 'teaser' && <p className="date">{t('sec1_date')}</p>}
                        </div>
                    </div>
                    <div className="watch-box GtmModuleData-btn-text" onClick={playerVideo}>
                        <div className="watch-text">{t('sec1_watch')}</div>
                        <div className="watch-icon">
                            <IconPlay fillBg="#fff" fillTrangle="#000" />
                        </div>
                    </div>
                    <div className="red-dot">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/reddot-black.webp')}
                            src={require('@publicLocal/delta2max/reddot-black.png')}
                            alt={t('sec1_subtitle')}
                            aria-label={t('sec1_subtitle')}
                        />
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
